/*
 * Recrutamento — liga o botao "Quero candidatar-me" de cada vaga ao formulario.
 *
 * A pagina tem uma seccao collapsible-tabs por vaga e UM unico formulario
 * (Shopify Forms) no fim, partilhado por todas. Sem isto, as candidaturas
 * chegam sem dizer a que vaga se referem.
 *
 * O formulario e desenhado pela app dentro de um shadow root (mode: "open"),
 * de forma assincrona, e usa React. Ha dois tipos de campo a considerar:
 *
 *  - campos nativos (<select>, <input>, <textarea>): escrevemos pelo setter
 *    nativo seguido de input/change, senao o React ignora a atribuicao;
 *  - o seletor proprio da app, que NAO e um <select>: e um <p> com a
 *    etiqueta mais um <button aria-expanded> que abre uma lista de
 *    div[role="option"]. Aqui a unica forma fiavel e imitar o utilizador —
 *    abrir e clicar na opcao — para os handlers da app correrem.
 *
 * Se nao houver campo de vaga, ou se nenhuma opcao corresponder, o script
 * nao faz nada e deixa o formulario como estava.
 */
(function () {
  'use strict';

  /* A loja publica PT, EN e ES: o rotulo do campo pode vir traduzido.
     NAO incluir "candidat": o botao diz "CANDIDATAR-ME" e o texto do bloco
     do ultimo campo pode engoli-lo, fazendo-nos escrever no campo errado. */
  var CAMPO = /vaga|vacante|vacancy|posi[cç][aã]o|position|puesto/i;
  var LIMITE_MS = 30000;

  /* "Estofador (a)" na pagina vs "Estofador(a)" na app: normalizar apaga a
     diferenca, tal como acentos e pontuacao. */
  function normalizar(txt) {
    return String(txt || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\(a\)/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function combina(textoOpcao, vaga) {
    var a = normalizar(textoOpcao);
    var b = normalizar(vaga);
    if (!a || !b) return false;
    return a === b || a.indexOf(b) === 0 || b.indexOf(a) === 0;
  }

  /* --- 1. Descobrir a vaga a partir do botao clicado ------------------- */

  var vagaEmMemoria = '';

  function ligarBotoes() {
    var seccoes = document.querySelectorAll('.shopify-section.section-collapsible-tabs');
    Array.prototype.forEach.call(seccoes, function (seccao) {
      var botao = seccao.querySelector('.collapsible-tabs__button');
      var cab = seccao.querySelector('.section-dropdown__heading');
      var titulo = cab ? cab.textContent.trim() : '';
      if (!botao || !titulo) return;
      botao.addEventListener('click', function () {
        vagaEmMemoria = titulo;
        falhadas = {};
        acompanhar();
      });
    });
  }

  /* Deliberadamente SEM sessionStorage. O botao e uma ancora na mesma
     pagina, portanto nao ha recarregamento a atravessar — guardar a vaga
     entre visitas so criava o risco de mostrar a vaga ERRADA: se a escolha
     anterior ficasse gravada e a nova nao tivesse opcao correspondente, o
     candidato via a vaga antiga preenchida e podia submete-la assim. */
  function vagaEscolhida() {
    return new URLSearchParams(window.location.search).get('vaga') || vagaEmMemoria || '';
  }

  /* --- 2. Onde procurar: documento e shadow roots abertos -------------- */

  function raizes() {
    var out = [document];
    Array.prototype.forEach.call(document.querySelectorAll('*'), function (el) {
      if (el.shadowRoot) out.push(el.shadowRoot);
    });
    return out;
  }

  function porId(lista, raiz) {
    var out = [];
    String(lista || '')
      .split(/\s+/)
      .forEach(function (id) {
        if (!id) return;
        var el = raiz.getElementById ? raiz.getElementById(id) : document.getElementById(id);
        if (el) out.push(el);
      });
    return out;
  }

  /* --- 3. O seletor proprio da app ------------------------------------- */

  /* Estrutura observada no formulario 956696:
       <div>
         <p id="…-selector-label">Posição a que se candidata</p>
         <button aria-expanded aria-labelledby="…-selector-label …-selector-value">
           <span id="…-selector-value">valor escolhido</span>
         </button>
         (a lista de div[role="option"] so existe depois de abrir)
       </div>
     O seletor do indicativo telefonico tem a mesma classe, mas identifica-se
     por aria-label ("Country code, …"), que nao passa no CAMPO. */
  function seletores() {
    var out = [];
    raizes().forEach(function (raiz) {
      Array.prototype.forEach.call(raiz.querySelectorAll('button[aria-expanded]'), function (botao) {
        var rotulados = porId(botao.getAttribute('aria-labelledby'), raiz);
        var texto = rotulados
          .map(function (e) {
            return e.textContent;
          })
          .join(' ');
        texto += ' ' + (botao.getAttribute('aria-label') || '');
        if (!CAMPO.test(texto)) return;
        var valorEl = rotulados.filter(function (e) {
          return /-value$/.test(e.id || '');
        })[0];
        out.push({ botao: botao, caixa: botao.parentElement, valorEl: valorEl || null });
      });
    });
    return out;
  }

  function valorDoSeletor(sel) {
    return sel.valorEl ? sel.valorEl.textContent.trim() : '';
  }

  var aAbrir = false;
  /* Vagas para as quais ja sabemos que nao existe opcao. Sem isto, a sonda
     periodica reabriria a lista de 300 em 300 ms durante meio minuto. */
  var falhadas = {};

  function aplicarSeletor(vaga, feito) {
    var sels = seletores();
    if (!sels.length) return feito(false);
    var sel = sels[0];

    if (combina(valorDoSeletor(sel), vaga)) return feito(true);
    if (aAbrir || falhadas[normalizar(vaga)]) return feito(false);

    aAbrir = true;
    var botao = sel.botao;
    if (botao.getAttribute('aria-expanded') !== 'true') botao.click();

    var inicio = Date.now();
    (function esperarOpcoes() {
      var opcoes = sel.caixa.querySelectorAll('[role="option"]');
      if (!opcoes.length && Date.now() - inicio < 1500) {
        setTimeout(esperarOpcoes, 50);
        return;
      }
      var alvo = Array.prototype.filter.call(opcoes, function (o) {
        return combina(o.textContent, vaga);
      })[0];

      if (!alvo) {
        /* nao ha opcao para esta vaga: fechar e nao voltar a tentar */
        falhadas[normalizar(vaga)] = true;
        if (botao.getAttribute('aria-expanded') === 'true') botao.click();
        aAbrir = false;
        return feito(false);
      }

      alvo.click();
      setTimeout(function () {
        aAbrir = false;
        feito(combina(valorDoSeletor(sel), vaga));
      }, 150);
    })();
  }

  /* --- 4. Campos nativos ----------------------------------------------- */

  var CAMPOS = 'select, input, textarea';

  function blocoDoCampo(campo) {
    var el = campo.parentElement;
    if (!el) return null;
    for (var i = 0; i < 5; i++) {
      var pai = el.parentElement;
      if (!pai || pai.querySelectorAll(CAMPOS).length > 1) break;
      el = pai;
    }
    return el;
  }

  function etiquetaDe(campo, raiz) {
    var partes = [campo.name, campo.id, campo.getAttribute('aria-label'), campo.placeholder];
    if (campo.labels && campo.labels.length) {
      Array.prototype.forEach.call(campo.labels, function (l) {
        partes.push(l.textContent);
      });
    }
    porId(campo.getAttribute('aria-labelledby'), raiz).forEach(function (e) {
      partes.push(e.textContent);
    });
    var envolvente = campo.closest('label');
    if (envolvente) partes.push(envolvente.textContent);

    var bloco = blocoDoCampo(campo);
    var textoBloco = '';
    if (bloco) {
      textoBloco = bloco.textContent || '';
      Array.prototype.forEach.call(campo.options || [], function (o) {
        textoBloco = textoBloco.split(o.textContent).join(' ');
      });
    }
    return { explicito: partes.filter(Boolean).join(' '), bloco: textoBloco };
  }

  function pontuar(campo, raiz) {
    var e = etiquetaDe(campo, raiz);
    var forte = CAMPO.test(e.explicito);
    var fraco = CAMPO.test(e.bloco);
    if (!forte && !fraco) return 0;
    var p = forte ? 10 : 4;
    if (campo.tagName === 'SELECT') p += 2;
    return p;
  }

  function procurarCampo() {
    var melhor = null;
    var melhorP = 0;
    raizes().forEach(function (raiz) {
      Array.prototype.forEach.call(raiz.querySelectorAll('select, input[type="text"], textarea'), function (campo) {
        var p = pontuar(campo, raiz);
        if (p > melhorP) {
          melhorP = p;
          melhor = campo;
        }
      });
    });
    return melhor;
  }

  function definirValor(campo, valor) {
    var proto =
      campo.tagName === 'SELECT'
        ? window.HTMLSelectElement.prototype
        : campo.tagName === 'TEXTAREA'
          ? window.HTMLTextAreaElement.prototype
          : window.HTMLInputElement.prototype;
    var desc = Object.getOwnPropertyDescriptor(proto, 'value');
    if (desc && desc.set) {
      desc.set.call(campo, valor);
    } else {
      campo.value = valor;
    }
    campo.dispatchEvent(new Event('input', { bubbles: true }));
    campo.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function aplicarNativo(vaga) {
    var campo = procurarCampo();
    if (!campo) return false;
    if (campo.tagName === 'SELECT') {
      var opcoes = Array.prototype.slice.call(campo.options || []);
      var alvo = opcoes.filter(function (o) {
        return combina(o.textContent, vaga) || combina(o.value, vaga);
      })[0];
      if (!alvo) return false;
      if (campo.value === alvo.value) return true;
      definirValor(campo, alvo.value);
    } else {
      if (campo.value === vaga) return true;
      definirValor(campo, vaga);
    }
    return true;
  }

  /* --- 5. Orquestracao -------------------------------------------------- */

  function aplicar(vaga, feito) {
    feito = feito || function () {};
    if (!vaga) return feito(false);
    if (aplicarNativo(vaga)) return feito(true);
    aplicarSeletor(vaga, feito);
  }

  var observador = null;
  var sonda = null;
  var relogio = null;

  function parar() {
    if (observador) observador.disconnect();
    if (sonda) clearInterval(sonda);
    if (relogio) clearTimeout(relogio);
    observador = null;
    sonda = null;
    relogio = null;
  }

  function tentar() {
    try {
      aplicar(vagaEscolhida(), function (ok) {
        if (ok) parar();
      });
    } catch (e) {
      /* nunca partir a pagina por causa disto */
    }
  }

  /* O formulario e injetado no DOM visivel -> a observacao apanha-o de
     imediato. Mas se a app o montar so dentro do shadow root, nao ha
     mutacao nenhuma para observar: dai a sonda periodica. */
  function acompanhar() {
    parar();
    tentar();
    observador = new MutationObserver(tentar);
    observador.observe(document.documentElement, { childList: true, subtree: true });
    sonda = setInterval(tentar, 300);
    relogio = setTimeout(parar, LIMITE_MS);
  }

  /* Deep link ?vaga=: alem de preencher o formulario, abrir a vaga certa e
     levar o visitante ate ela. Sem isto quem chega de um anuncio aterra no
     topo, com todos os separadores fechados, sem ver a vaga que o trouxe.
     O tema so liga os handlers do acordeao depois do nosso arranque, dai as
     tentativas repetidas. */
  function abrirVaga(vaga, tentativa) {
    tentativa = tentativa || 0;
    var seccoes = document.querySelectorAll('.shopify-section.section-collapsible-tabs');
    for (var i = 0; i < seccoes.length; i++) {
      var cab = seccoes[i].querySelector('.section-dropdown__heading');
      if (!cab || !combina(cab.textContent, vaga)) continue;
      var caixa = seccoes[i].querySelector('.section-dropdown');
      var gatilho = seccoes[i].querySelector('.section-dropdown__trigger');
      var aberta = caixa && caixa.className.indexOf('section-dropdown--open') !== -1;
      if (!aberta && gatilho) gatilho.click();
      aberta = caixa && caixa.className.indexOf('section-dropdown--open') !== -1;
      if (aberta) {
        seccoes[i].scrollIntoView({ behavior: 'smooth', block: 'start' });
        return true;
      }
      break;
    }
    if (tentativa < 6) {
      setTimeout(function () {
        abrirVaga(vaga, tentativa + 1);
      }, 250);
    }
    return false;
  }

  /* --- Destaque da vaga aberta ----------------------------------------- */

  /* Sao seis seccoes independentes, por isso o CSS sozinho nao consegue
     saber se ALGUMA esta aberta — sem essa informacao, "escurecer as
     fechadas" escureceria as seis no estado inicial. Marcamos o body. */
  function marcarEstado() {
    var abertas = document.querySelectorAll('.section-collapsible-tabs .section-dropdown--open');
    var cl = document.body.classList;
    if (abertas.length) cl.add('pistacho-vaga-aberta');
    else cl.remove('pistacho-vaga-aberta');
  }

  function vigiarAcordeao() {
    var caixas = document.querySelectorAll('.shopify-section.section-collapsible-tabs .section-dropdown');
    if (!caixas.length) return;
    var obs = new MutationObserver(marcarEstado);
    Array.prototype.forEach.call(caixas, function (c) {
      obs.observe(c, { attributes: true, attributeFilter: ['class'] });
    });
    marcarEstado();
  }

  function arrancar() {
    try {
      vigiarAcordeao();
      ligarBotoes();
      var pedida = new URLSearchParams(window.location.search).get('vaga');
      if (pedida) abrirVaga(pedida);
      acompanhar();
    } catch (e) {
      /* silencioso: sem campo ou sem formulario, a pagina fica como estava */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
